/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type FolderContainer_viewer$ref = any;
export type PortfolioItemsSortByTypes = "CUSTOM" | "NET_PRICE_ASC" | "NET_PRICE_DESC" | "PRICE_ASC" | "PRICE_DESC" | "RECENTLY_CREATED" | "RECENTLY_MODIFIED" | "%future added value";
export type FolderContainerRefetchQueryVariables = {
    readonly first: number;
    readonly after?: string | null;
    readonly hasUserId: boolean;
    readonly portfolioIds?: ReadonlyArray<string | null> | null;
    readonly projectId: string;
    readonly searchTerm?: string | null;
    readonly sortBy?: PortfolioItemsSortByTypes | null;
    readonly loadPortfolioData: boolean;
    readonly selectedItemIds: ReadonlyArray<string | null>;
    readonly useProjectEndpoint: boolean;
    readonly userId: string;
    readonly userIds: ReadonlyArray<string | null>;
    readonly itemId: string;
    readonly shouldFetchItem: boolean;
    readonly showSeller: boolean;
    readonly itemIds?: ReadonlyArray<string | null> | null;
    readonly shouldFetchConversation: boolean;
    readonly shouldFetchTransaction: boolean;
    readonly zipCode: string;
    readonly country: string;
    readonly canCheckZipCode: boolean;
    readonly conversationId: string;
    readonly hasConversationId: boolean;
    readonly isTrade: boolean;
    readonly page: number;
};
export type FolderContainerRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FolderContainer_viewer$ref;
    } | null;
};
export type FolderContainerRefetchQuery = {
    readonly response: FolderContainerRefetchQueryResponse;
    readonly variables: FolderContainerRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "first",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "after",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "portfolioIds",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "projectId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "searchTerm",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "sortBy",
            "type": "PortfolioItemsSortByTypes",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "selectedItemIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "useProjectEndpoint",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "itemId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFetchItem",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "showSeller",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "itemIds",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFetchConversation",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFetchTransaction",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "zipCode",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "country",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "canCheckZipCode",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "conversationId",
            "type": "ID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasConversationId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isTrade",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Int!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Literal",
        "name": "numItems",
        "value": 2
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "displayName",
        "args": null,
        "storageKey": null
    } as any), v3 = [
        (v2 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "url",
            "args": null,
            "storageKey": null
        } as any)
    ], v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        (v5 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "abbreviation",
            "args": null,
            "storageKey": null
        } as any)
    ], v7 = ({
        "kind": "Literal",
        "name": "portfolioTypes",
        "value": [
            "HEART"
        ]
    } as any), v8 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "portfolioItemId",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v11 = [
        (v10 /*: any*/),
        (v4 /*: any*/)
    ], v12 = ({
        "kind": "Literal",
        "name": "first",
        "value": 1
    } as any), v13 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isVerifiedTrade",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "firstValidShippingAddress",
        "storageKey": null,
        "args": null,
        "concreteType": "Address",
        "plural": false,
        "selections": (v11 /*: any*/)
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "addressBook",
        "storageKey": null,
        "args": null,
        "concreteType": "AddressBook",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "addressList",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sourceId",
                        "args": null,
                        "storageKey": null
                    },
                    (v10 /*: any*/),
                    (v2 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "formattedAddress",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "displayCountry",
                        "args": null,
                        "storageKey": null
                    },
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "line1",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "line2",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "country",
                        "args": null,
                        "storageKey": null
                    },
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "zipCode",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "phoneNumber",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "validation",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AddressValidation",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "buyerShipping",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ValidationResult",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "valid",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    },
                    (v4 /*: any*/)
                ]
            }
        ]
    } as any), v22 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "tradeFirm",
        "storageKey": null,
        "args": null,
        "concreteType": "TradeFirmType",
        "plural": false,
        "selections": (v11 /*: any*/)
    } as any), v23 = ({
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userId"
    } as any), v24 = ({
        "kind": "Variable",
        "name": "itemId",
        "variableName": "itemId"
    } as any), v25 = [
        (v23 /*: any*/),
        (v24 /*: any*/)
    ], v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v27 = [
        (v26 /*: any*/)
    ], v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCustom",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isSold",
        "args": null,
        "storageKey": null
    } as any), v31 = [
        (v23 /*: any*/)
    ], v32 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "is1stdibsBilledQuote",
        "args": null,
        "storageKey": null
    } as any), v33 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "is1stdibsWhiteGloveQuote",
        "args": null,
        "storageKey": null
    } as any), v34 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "handlingTimeDisplay",
        "args": null,
        "storageKey": null
    } as any), v35 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "convertedAmountList",
        "storageKey": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "plural": true,
        "selections": [
            (v17 /*: any*/),
            (v26 /*: any*/)
        ]
    } as any), v36 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "totalAmount",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": [
            (v17 /*: any*/),
            (v26 /*: any*/),
            (v35 /*: any*/)
        ]
    } as any), v37 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "buyerServiceMethodDisplay",
        "args": null,
        "storageKey": null
    } as any), v38 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "handlingTime",
        "storageKey": null,
        "args": null,
        "concreteType": "Period",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "numberOfUnits",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v39 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "regionName",
        "args": null,
        "storageKey": null
    } as any), v40 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "serviceMethod",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentServiceMethod",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceType",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceMethodType",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "region",
                "storageKey": null,
                "args": null,
                "concreteType": "Region",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                    },
                    (v39 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "regionType",
                        "args": null,
                        "storageKey": null
                    },
                    (v4 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "regionBoundary",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RegionBoundary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "type",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RegionBoundaryType",
                                "plural": false,
                                "selections": [
                                    (v5 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "windowMin",
                "storageKey": null,
                "args": null,
                "concreteType": "Period",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": "numberOfDays",
                        "name": "numberOfUnits",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            (v4 /*: any*/)
        ]
    } as any), v41 = [
        (v35 /*: any*/)
    ], v42 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCanceled",
        "args": null,
        "storageKey": null
    } as any), v43 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasCompletedCheckout",
        "args": null,
        "storageKey": null
    } as any), v44 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v45 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
    } as any), v46 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isPublic",
        "args": null,
        "storageKey": null
    } as any), v47 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "ownerId",
        "args": null,
        "storageKey": null
    } as any), v48 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalResults",
        "args": null,
        "storageKey": null
    } as any), v49 = ({
        "kind": "LinkedField",
        "alias": "totalPortfolioItems",
        "name": "items",
        "storageKey": "items(first:1)",
        "args": [
            (v12 /*: any*/)
        ],
        "concreteType": "PortfolioItemsConnection",
        "plural": false,
        "selections": [
            (v48 /*: any*/)
        ]
    } as any), v50 = ({
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    } as any), v51 = ({
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    } as any), v52 = ({
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
    } as any), v53 = ({
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    } as any), v54 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "numberOfPages",
        "args": null,
        "storageKey": null
    } as any), v55 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v56 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
    } as any), v57 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "convertedAmountList",
        "storageKey": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "plural": true,
        "selections": [
            (v26 /*: any*/),
            (v17 /*: any*/)
        ]
    } as any), v58 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
    } as any), v59 = [
        ({
            "kind": "Literal",
            "name": "formatType",
            "value": "MOBILE"
        } as any)
    ], v60 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": null,
        "concreteType": "Item",
        "plural": false,
        "selections": [
            (v10 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "vertical",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                    (v10 /*: any*/),
                    (v4 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "sellerProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SellerProfile",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "company",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            (v4 /*: any*/),
            (v29 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstPhotoWebPath",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "size",
                        "value": "large"
                    }
                ],
                "storageKey": "firstPhotoWebPath(size:\"large\")"
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "contemporaryTrackingString",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "categoryPath",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "retailPrice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v27 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                            (v17 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "prices",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Price",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "amount",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": [
                                    (v26 /*: any*/),
                                    (v57 /*: any*/)
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pricePerPiece",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hidePrice",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "negotiable",
                                "args": null,
                                "storageKey": null
                            },
                            (v58 /*: any*/),
                            (v44 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "localizedPdpUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isArt",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "classification",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemClassification",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "creationDate",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "creators",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemCreator",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "creator",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Creator",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            (v4 /*: any*/)
                        ]
                    },
                    (v4 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "attribution",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "canMultipleQuantityBePurchased",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isOnHold",
                "args": null,
                "storageKey": null
            },
            (v30 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasRequestedHoldForBuyer",
                "args": (v31 /*: any*/),
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "activeHold",
                "storageKey": null,
                "args": null,
                "concreteType": "Hold",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "expirationDate",
                        "args": null,
                        "storageKey": null
                    },
                    (v4 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuotes",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isLocalPickup",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isComplimentary",
                        "args": null,
                        "storageKey": null
                    },
                    (v34 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "serviceMethod",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "region",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Region",
                                "plural": false,
                                "selections": [
                                    (v39 /*: any*/),
                                    (v4 /*: any*/)
                                ]
                            },
                            (v4 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                            (v35 /*: any*/),
                            (v26 /*: any*/)
                        ]
                    },
                    (v4 /*: any*/)
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isCustomizable",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isMultiSku",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "displayPrice",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isTrade",
                        "variableName": "isTrade"
                    },
                    {
                        "kind": "Literal",
                        "name": "page",
                        "value": "searchAndBrowse"
                    }
                ],
                "concreteType": "ItemDisplayPriceType",
                "plural": true,
                "selections": [
                    (v57 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "quantityDisplay",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "percentageOff",
                        "args": null,
                        "storageKey": null
                    },
                    (v58 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showPriceLabel",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showPriceVariability",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "lowestShipmentQuote",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "complimentaryShipping",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v41 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "serviceMethod",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isWhiteGlove",
                                "args": null,
                                "storageKey": null
                            },
                            (v4 /*: any*/)
                        ]
                    },
                    (v4 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": "productPhotos",
                "name": "photos",
                "storageKey": "photos(limit:1)",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "limit",
                        "value": 1
                    }
                ],
                "concreteType": "ItemPhoto",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "placeholder",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "smallPath",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "masterOrZoomPath",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "versions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhotoVersion",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "webPath",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    (v4 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "quickViewDisplay",
                "storageKey": null,
                "args": null,
                "concreteType": "QuickViewDisplayType",
                "plural": false,
                "selections": [
                    (v29 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": "mobileTitle",
                        "name": "title",
                        "args": (v59 /*: any*/),
                        "storageKey": "title(formatType:\"MOBILE\")"
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "paragraphs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "QuickViewParagraph",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "key",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "text",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": "mobileText",
                                "name": "text",
                                "args": (v59 /*: any*/),
                                "storageKey": "text(formatType:\"MOBILE\")"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "tilesProjects",
                        "name": "projects",
                        "storageKey": null,
                        "args": (v13 /*: any*/),
                        "concreteType": "Project",
                        "plural": true,
                        "selections": [
                            (v5 /*: any*/),
                            (v10 /*: any*/),
                            (v4 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": "pdpDisplayInfo",
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": [
                            (v23 /*: any*/),
                            {
                                "kind": "Literal",
                                "name": "page",
                                "value": "pdp"
                            }
                        ],
                        "concreteType": "ItemDisplayInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pricing",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PriceInfoDisplay",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showRetail",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showNet",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showSale",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showPUR",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showSold",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showOnHold",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v61 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "note",
        "args": null,
        "storageKey": null
    } as any), v62 = ({
        "kind": "LinkedField",
        "alias": "portfolioItems",
        "name": "items",
        "storageKey": null,
        "args": [
            (v50 /*: any*/),
            (v51 /*: any*/),
            {
                "kind": "Variable",
                "name": "page",
                "variableName": "page"
            },
            (v52 /*: any*/),
            (v53 /*: any*/)
        ],
        "concreteType": "PortfolioItemsConnection",
        "plural": false,
        "selections": [
            (v48 /*: any*/),
            (v54 /*: any*/),
            (v55 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PortfolioItemsEdge",
                "plural": true,
                "selections": [
                    (v56 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioItemV2",
                        "plural": false,
                        "selections": [
                            (v60 /*: any*/),
                            (v4 /*: any*/),
                            (v9 /*: any*/),
                            (v61 /*: any*/)
                        ]
                    }
                ]
            }
        ]
    } as any), v63 = [
        (v50 /*: any*/),
        (v51 /*: any*/),
        (v52 /*: any*/),
        (v53 /*: any*/)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "FolderContainerRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "FolderContainer_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "FolderContainerRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": "trendingCategories",
                            "name": "trending",
                            "storageKey": "trending(categoryLevels:3,numItems:2,trendType:\"CATEGORY\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "categoryLevels",
                                    "value": 3
                                },
                                (v1 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "trendType",
                                    "value": "CATEGORY"
                                }
                            ],
                            "concreteType": "TrendingModules",
                            "plural": true,
                            "selections": (v3 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "trendingAttributes",
                            "name": "trending",
                            "storageKey": "trending(numItems:2,trendType:\"ATTRIBUTE\")",
                            "args": [
                                (v1 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "trendType",
                                    "value": "ATTRIBUTE"
                                }
                            ],
                            "concreteType": "TrendingModules",
                            "plural": true,
                            "selections": (v3 /*: any*/)
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "onlyTradeRequestsQuote",
                            "name": "isEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "useOldPdpShippingModals"
                                }
                            ],
                            "storageKey": "isEnabled(key:\"useOldPdpShippingModals\")"
                        },
                        (v4 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "geography",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Geography",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "countries",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "GeographyObject",
                                    "plural": true,
                                    "selections": (v6 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "usStates",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "GeographyObject",
                                    "plural": true,
                                    "selections": (v6 /*: any*/)
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isVisuallySimilarEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "VISUALLY_SIMILAR"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "loadPortfolioData",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "heartItemMatches",
                                    "name": "portfolioItemMatches",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "itemIds",
                                            "variableName": "selectedItemIds"
                                        },
                                        (v7 /*: any*/),
                                        (v8 /*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemV2",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v9 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": (v11 /*: any*/)
                                        },
                                        (v4 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "userPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        (v12 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/)
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": (v11 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v13 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v14 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "email",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        (v10 /*: any*/),
                                        (v18 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "relevantShippingInfo",
                                    "storageKey": null,
                                    "args": (v25 /*: any*/),
                                    "concreteType": "QueryRelevantShippingInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipmentQuote",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ShipmentQuote",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "subTotalAmount",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FinancialAmount",
                                                    "plural": false,
                                                    "selections": (v27 /*: any*/)
                                                },
                                                (v28 /*: any*/),
                                                (v4 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "projects",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 200
                                        },
                                        (v8 /*: any*/)
                                    ],
                                    "concreteType": "ProjectConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ProjectEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Project",
                                                    "plural": false,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        (v5 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "portfolio",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "PortfolioV2",
                                                            "plural": false,
                                                            "selections": (v11 /*: any*/)
                                                        },
                                                        (v4 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "shouldFetchItem",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "item",
                                    "storageKey": null,
                                    "args": [
                                        (v24 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "pageType",
                                            "value": "SHIPPING_MODAL"
                                        }
                                    ],
                                    "concreteType": "Item",
                                    "plural": false,
                                    "selections": [
                                        (v29 /*: any*/),
                                        (v30 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "seller",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Seller",
                                            "plural": false,
                                            "selections": [
                                                (v10 /*: any*/),
                                                (v4 /*: any*/),
                                                {
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "condition": "hasUserId",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "favoritesByUser",
                                                            "storageKey": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "userIds",
                                                                    "variableName": "userId"
                                                                }
                                                            ],
                                                            "concreteType": "Favorite",
                                                            "plural": true,
                                                            "selections": (v11 /*: any*/)
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "hasPreQuotedShipping",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": "itemIsOnHold",
                                            "name": "isOnHold",
                                            "args": (v31 /*: any*/),
                                            "storageKey": null
                                        },
                                        (v4 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "address",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Address",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": "itemAddress",
                                                    "name": "displayCityStateCountry",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "fullCountryName",
                                                            "value": true
                                                        }
                                                    ],
                                                    "storageKey": "displayCityStateCountry(fullCountryName:true)"
                                                },
                                                (v4 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "relevantShippingInfo",
                                    "storageKey": null,
                                    "args": (v25 /*: any*/),
                                    "concreteType": "QueryRelevantShippingInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipment",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Shipment",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "shippingAddress",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Address",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "displayCityStateCountry",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/)
                                                    ]
                                                },
                                                (v4 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipmentQuote",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ShipmentQuote",
                                            "plural": false,
                                            "selections": [
                                                (v28 /*: any*/),
                                                (v10 /*: any*/),
                                                (v32 /*: any*/),
                                                (v33 /*: any*/),
                                                (v34 /*: any*/),
                                                (v36 /*: any*/),
                                                (v37 /*: any*/),
                                                (v38 /*: any*/),
                                                (v40 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "buyerSubTotalAmount",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FinancialAmount",
                                                    "plural": false,
                                                    "selections": (v41 /*: any*/)
                                                },
                                                (v4 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shipmentQuotes",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        },
                                        (v24 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "searchView",
                                            "value": "IGNORE_LOCAL_PICKUP"
                                        }
                                    ],
                                    "concreteType": "ShipmentQuotesConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ShipmentQuotesEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ShipmentQuote",
                                                    "plural": false,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v36 /*: any*/),
                                                        (v37 /*: any*/),
                                                        (v38 /*: any*/),
                                                        (v40 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "buyerSubTotalAmount",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "FinancialAmount",
                                                            "plural": false,
                                                            "selections": [
                                                                (v26 /*: any*/),
                                                                (v35 /*: any*/)
                                                            ]
                                                        },
                                                        (v4 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "shouldFetchConversation",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "buyerItemConversation",
                                    "storageKey": null,
                                    "args": (v25 /*: any*/),
                                    "concreteType": "Conversation",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v10 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "shouldFetchTransaction",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "transactions",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "buyerId",
                                            "variableName": "userIds"
                                        },
                                        (v12 /*: any*/),
                                        {
                                            "kind": "Variable",
                                            "name": "itemId",
                                            "variableName": "itemIds"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": "createdDate desc"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "viewName",
                                            "value": "mc.conversationTransaction"
                                        }
                                    ],
                                    "concreteType": "TransactionConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TransactionEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Transaction",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v42 /*: any*/),
                                                        (v43 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "lastShipmentQuote",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ShipmentQuote",
                                                            "plural": false,
                                                            "selections": [
                                                                (v44 /*: any*/),
                                                                (v4 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasConversationId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conversation",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "conversationId",
                                            "variableName": "conversationId"
                                        }
                                    ],
                                    "concreteType": "Conversation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "transaction",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v10 /*: any*/),
                                                (v42 /*: any*/),
                                                (v43 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "originalBuyer",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConversationMember",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "user",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "profile",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Profile",
                                                            "plural": false,
                                                            "selections": [
                                                                (v15 /*: any*/),
                                                                (v16 /*: any*/)
                                                            ]
                                                        },
                                                        (v14 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ]
                                                },
                                                (v4 /*: any*/)
                                            ]
                                        },
                                        (v4 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "canCheckZipCode",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "zipCodeLookUp",
                                    "name": "zipCode",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "country",
                                            "variableName": "country"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "zipCode",
                                            "variableName": "zipCode"
                                        }
                                    ],
                                    "concreteType": "Address",
                                    "plural": true,
                                    "selections": [
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v4 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": false,
                            "condition": "useProjectEndpoint",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "folderPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        (v12 /*: any*/),
                                        {
                                            "kind": "Variable",
                                            "name": "portfolioIds",
                                            "variableName": "portfolioIds"
                                        }
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v5 /*: any*/),
                                                        (v45 /*: any*/),
                                                        (v46 /*: any*/),
                                                        (v47 /*: any*/),
                                                        (v49 /*: any*/),
                                                        (v62 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "items",
                                                            "storageKey": null,
                                                            "args": (v63 /*: any*/),
                                                            "concreteType": "PortfolioItemsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                (v48 /*: any*/),
                                                                (v54 /*: any*/),
                                                                (v55 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "edges",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "PortfolioItemsEdge",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v56 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "node",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "PortfolioItemV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v60 /*: any*/),
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "__typename",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                (v9 /*: any*/),
                                                                                (v61 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedHandle",
                                                            "alias": null,
                                                            "name": "items",
                                                            "args": (v63 /*: any*/),
                                                            "handle": "connection",
                                                            "key": "ItemsRefetchWrapper_items",
                                                            "filters": [
                                                                "searchTerm",
                                                                "sortBy"
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "useProjectEndpoint",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "project",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "projectId"
                                        }
                                    ],
                                    "concreteType": "Project",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "portfolio",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfolioV2",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v10 /*: any*/),
                                                (v5 /*: any*/),
                                                (v45 /*: any*/),
                                                (v46 /*: any*/),
                                                (v47 /*: any*/),
                                                (v49 /*: any*/),
                                                (v62 /*: any*/)
                                            ]
                                        },
                                        (v4 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "FolderContainerRefetchQuery",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/FolderContainerRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '5f22aa8e9dc8045c2c2087cd501f0fef';
export default node;
